<template>
  <div>
    <EtfTable></EtfTable>
  </div>
</template>

<script>
import { EtfTable } from "./components/index.js";
export default {
  components: {
    EtfTable,
  },
};
</script>

<style lang="scss" scoped>
</style>